import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible";
import { ChevronDown, ChevronUp } from "lucide-react";
import { Button } from "@/components/ui/button";
import BasicInfoFields from "./BasicInfoFields";
import LocationFields from "./LocationFields";
import CurrencySelector from "./CurrencySelector";
import LanguageSelector from "./LanguageSelector";
interface PersonalInfoProps {
  firstName: string;
  lastName: string;
  email: string;
  city: string;
  country: string;
  language: string;
  currency: string;
  loading: boolean;
  onFirstNameChange: (value: string) => void;
  onLastNameChange: (value: string) => void;
  onCityChange: (value: string) => void;
  onCountryChange: (value: string) => void;
  onLanguageChange: (value: string) => void;
  onCurrencyChange: (value: string) => void;
  onSave: () => void;
  onToggleSection?: (isOpen: boolean) => void;
}
const PersonalInfo = ({
  firstName,
  lastName,
  email,
  city,
  country,
  language,
  currency,
  loading,
  onFirstNameChange,
  onLastNameChange,
  onCityChange,
  onCountryChange,
  onLanguageChange,
  onCurrencyChange,
  onSave,
  onToggleSection
}: PersonalInfoProps) => {
  const {
    t
  } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const handleToggle = (open: boolean) => {
    setIsOpen(open);
    if (onToggleSection) {
      onToggleSection(open);
    }
  };
  return <div className="space-y-4">
      <Collapsible open={isOpen} onOpenChange={handleToggle} className="w-full">
        <CollapsibleTrigger asChild>
          <div className="flex items-center justify-between bg-accent/50 p-3 rounded-md cursor-pointer">
            <h3 className="text-lg font-semibold">
              {t("settings.profile.title")}
            </h3>
            <Button variant="outline" size="sm" className="border border-primary/30 shadow-sm" onClick={e => {
            e.stopPropagation();
            handleToggle(!isOpen);
          }}>
              {isOpen ? <ChevronUp className="h-5 w-5" /> : <ChevronDown className="h-5 w-5" />}
              <span className="sr-only">{isOpen ? "Close" : "Open"}</span>
            </Button>
          </div>
        </CollapsibleTrigger>

        <CollapsibleContent className="space-y-4 pt-4 animate-accordion-down">
          <BasicInfoFields firstName={firstName} lastName={lastName} email={email} onFirstNameChange={onFirstNameChange} onLastNameChange={onLastNameChange} />

          <LocationFields city={city} country={country} onCityChange={onCityChange} onCountryChange={onCountryChange} />

          <div className="pt-4 border-t">
            <LanguageSelector value={language} onValueChange={onLanguageChange} />
          </div>

          <div className="pt-4 border-t">
            <CurrencySelector value={currency} onValueChange={onCurrencyChange} />
          </div>

          <Button onClick={onSave} disabled={loading} style={{
          backgroundColor: "#000835"
        }} className="w-full mt-4 bg-[#000835]">
            {loading ? t("common.saving") : t("common.save")}
          </Button>
        </CollapsibleContent>
      </Collapsible>
    </div>;
};
export default PersonalInfo;